import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Chief Financial Officer section for eligibility tab
 */
const ChiefFinancialofficerSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="chief-financial-officer-section-component"
    >
      <AccordionV2
        testId="chief-financial-officer"
        className="border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Chief Financial Officer" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4">
          <p>
            The corporate context in which the Chief Financial Officer functions
            will be considered in assessing potential nominees, including
            transparency of financial reporting; high standards of corporate
            behaviour, sound accounting practices; commitment to good corporate
            governance consistent with current standards and evolving
            guidelines; providing advice on strategic direction; and being an
            effective leader of the finance and accounting function. In
            addition, the Best Chief Financial Officer nominees will be
            evaluated on these three areas:
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Personal and Professional Qualities;</li>

            <li>Knowledge and Experience;</li>

            <li>Track Record and Accomplishments.</li>
          </ul>

          <p>Personal and Professional Qualities</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              Integrity: The CFO&apos;s integrity must be of the highest
              standard. He/She must exhibit the highest ethical behaviour and
              inculcate the same corporate culture top-down, across all levels
              within the organisation;
            </li>

            <li>
              Transparency: The CFO is someone who champions the need for
              greater accountability and transparency in corporate governance;
            </li>

            <li>
              Soft People Skills: The CFO must have the skills and abilities to
              address and manage the concerns of the various corporate
              constituents – the CEO, directors, unit managers, analysts,
              bankers, investors and the media – in an impartial manner;
            </li>

            <li>
              Confidence: The CFO must have the confidence to provide meaningful
              information about the company&apos;s accounts and finances at
              board meetings and with shareholders, investors and the media;
            </li>

            <li>
              Vision and Leadership: The CFO must possess sound business acumen,
              astute foresight and the ability to lead, inspire and guide
              his/her organisation to greater heights of growth, financial
              achievement and recognition;
            </li>

            <li>
              Innovation: The CFO is characterised as an innovator who has the
              ability to transform and shape the successful financial
              performance of his/her organisation while exercising sound
              business judgement and demonstrating excellence in his/her field.
            </li>
          </ul>

          <p>Knowledge and Experience</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              Knowledge Base: The CFO must have a sound understanding of all
              matters relating to the corporate regulatory compliance and
              reporting requirements of the company;
            </li>

            <li>
              Experience: While age is not the sole decisive factor, the CFO
              should ideally have spent at least three years in the finance
              function and three full years in his current company. Preferably
              the CFO should not be a newcomer to the industry in which he/she
              is currently working in;
            </li>

            <li>
              Professional Training: Possessing the necessary professional
              qualifications in accountancy or finance will be a plus.
              Accountancy and finance designations include the Chartered
              Accountant (“CA”), Certified Public Accountant (“CPA”) and
              Chartered Financial Analyst (“CFA”). Other finance-related
              tertiary qualifications will also be considered;
            </li>

            <li>
              Continuous Learning: The CFO should possess a desire for
              continuous learning and professional development.
            </li>
          </ul>

          <p>Track Record and Accomplishments</p>

          <ul className="list-outside list-disc pl-8">
            <li>
              Personal Achievements: The CFO&apos;s track record and
              accomplishments will be a key factor. The judges will consider the
              corporate deals, including M&As, rights issues etc, handled by the
              CFO during the year under review. The degree of difficulty of each
              corporate deal will also be taken into account. The ability of the
              CFO to create long-term shareholder value for the company is an
              important consideration;
            </li>

            <li>
              Corporate Reporting and Performance: The financial performance of
              an organisation is indicative of success or failure. Full and fair
              disclosure, sound financial management, integrity and a commitment
              to ethical business conduct are key indicators of a good CFO;
            </li>

            <li>
              Social Responsibility: In addition to a commitment to integrity
              and a passion for the future of business, a highly distinguished
              CFO uses his/her influence, skill and creativity to make
              significant contributions to the finance and accounting
              profession, industry and to the community;
            </li>

            <li>
              Global Competitiveness: Companies compete in a global marketplace.
              A successful CFO demonstrates global initiatives and regional
              drives that foster potential new markets abroad, enhance
              operations, aid in the establishment of foreign ventures or the
              expansion of foreign corporate affairs on an international scale.
              The CFO is a key pre-requisite for the success of the company
              competing in the global marketplace.
            </li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ChiefFinancialofficerSection;
